import { GetServerSideProps } from 'next';
import styled from 'styled-components';
import {
  useHtmlTranslation,
  useShippingCountry,
  useTranslation,
} from '@lib/hooks';

import Heading from '@components/Heading';
import ImageGallery from '@components/ImageGallery';
import BreedersPageWrapper from '@components/pageWrappers/Breeders';
import { OrderedList, Text, UnorderedList } from '@components/Typography';
import { ShippingCountry } from '@types';

const galleryImages = [
  '/images/breeders/Puppy-gallery1.jpg',
  '/images/breeders/Puppy-gallery2.jpg',
  '/images/breeders/Puppy-gallery3.jpg',
  '/images/breeders/Puppy-gallery4.jpg',
  '/images/breeders/Puppy-gallery5.jpg',
].map((src) => ({
  src,
  height: 660,
  width: 925,
}));

const MultiPWrapper = styled.span`
  p {
    margin-bottom: 1rem;
  }
`;

const Puppies = () => {
  const t = useTranslation();
  const tHtml = useHtmlTranslation();
  const { country } = useShippingCountry();

  return (
    <BreedersPageWrapper>
      <Heading>{t('breeders.incoming_puppies')}</Heading>
      {country === ShippingCountry.DK ? (
        <Text>{t('breeders.incoming_puppies.intro_dk')}</Text>
      ) : (
        <>
          <Text>{t('breeders.incoming_puppies.intro')}</Text>
          <OrderedList
            styleLi
            title={t('breeders.incoming_puppies.how_it_works.title')}
          >
            {tHtml('breeders.incoming_puppies.how_it_works.points')}
          </OrderedList>
          <MultiPWrapper>
            {tHtml('breeders.incoming_puppies.how_it_works.closer')}
          </MultiPWrapper>
        </>
      )}
      <ImageGallery images={galleryImages} />
      <Heading>{t('breeders.what_is_a_puppy_box')}</Heading>
      <Text>{t('breeders.box_content.intro')}</Text>
      <UnorderedList inset title={t('breeders.box_content.list_title')}>
        {tHtml('breeders.box_content.list_content')}
      </UnorderedList>
    </BreedersPageWrapper>
  );
};

export const getServerSideProps: GetServerSideProps = async () => ({
  props: {
    title: 'breeders.puppies_page',
  },
});

export default Puppies;
